export default "__VITE_ASSET__Bncm1GNC__"